interface PlaceholderLabelProps {
    title: string;
    benefit: string;
    className?: string;
}

/**
 * The title stays put. Hovering the parent `group` opens the benefit underneath,
 * smaller than the title, matching ProfileHint (action text-sm, reason text-xs).
 */
export function PlaceholderLabel({ title, benefit, className = '' }: PlaceholderLabelProps) {
    return (
        <span className="inline-flex max-w-full flex-col items-center text-center">
            <span className={className}>{title}</span>
            <span className="max-h-0 overflow-hidden transition-[max-height] duration-300 ease-out group-hover:max-h-16 group-focus-visible:max-h-16 motion-reduce:transition-none">
                <span className="mt-1 block max-w-[15rem] px-2 text-xs font-medium leading-snug">{benefit}</span>
            </span>
        </span>
    );
}
